import {
  Box,
  Button,
  HStack,
  Heading,
  Popover,
  VStack,
  useDisclosure
} from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useReviewContext } from "../state/ReviewContextProvider"
import InboxNavigator from "./InboxNavigator"
import useInboxContext from "./useInboxContext"
import { InboxGroupNode } from "./useInboxItems"

export function InboxPopover({
  onSelect,
  children,
  ...popoverProps
}: {
  onSelect?: (item: InboxGroupNode) => void
} & Popover.RootProps) {
  const reviewContext = useReviewContext()
  const disclosure = useDisclosure()

  const handleSelectInbox = (item: InboxGroupNode) => {
    reviewContext?.actions?.clearAllSelections?.()
    disclosure.onClose()
    onSelect?.(item)
  }

  return (
    <Popover.Root
      {...disclosure}
      closeOnInteractOutside
      closeOnEscape
      lazyMount
      unmountOnExit={false}
      onOpenChange={(e: { open: boolean }) =>
        e.open ? disclosure.onOpen() : disclosure.onClose()
      }
      {...popoverProps}
    >
      <Popover.Trigger asChild onClick={disclosure.onToggle}>
        <Box>{children}</Box>
      </Popover.Trigger>
      <Popover.Positioner>
        <Popover.Content p={0} w="min(420px, calc(100vw - 20px))">
          <Popover.Body p={0}>
            <InboxNavigator onSelect={handleSelectInbox} />
          </Popover.Body>
        </Popover.Content>
      </Popover.Positioner>
    </Popover.Root>
  )
}

const InboxSelector = () => {
  const {
    context: { query }
  } = useReviewContext()
  const { inbox, loading } = useInboxContext(query)

  const showLoading = loading === true || !inbox

  return (
    <VStack w="100%" alignItems="center" p={4}>
      <InboxPopover>
        <Button variant="solid" colorPalette="whiteAlpha" size="md">
          <HStack>
            <Pathicon icon="inbox-fill" />
            <Heading
              as="h1"
              size="md"
              lineClamp={1}
              maxW="200px"
              color="inherit"
              m={0}
            >
              {showLoading ? "Loading... " : inbox.meta.title}
            </Heading>
            <Pathicon icon="chevron-down" />
          </HStack>
        </Button>
      </InboxPopover>
    </VStack>
  )
}

export default InboxSelector
